import apiService from 'config/service';
import { Payload, IRequestRefundableFare, IGetRefundableFareTypeReturn } from './type';

export const postShareFreightWithTruckers = ({ encodedFreightId, truckersId }: Payload): Promise<void> =>
  apiService.post(`/freights/${encodedFreightId}/share`, { truckers: truckersId });

export const getTruckersRefundableFare = ({
  encodedFreightId,
}: IRequestRefundableFare): Promise<IGetRefundableFareTypeReturn> =>
  apiService.get(`/freights/${encodedFreightId}/truckers/refundable-fare`);
